import { render, staticRenderFns } from "./CoursePausedFloatingCard.vue?vue&type=template&id=34d81380&scoped=true"
import script from "./CoursePausedFloatingCard.vue?vue&type=script&lang=js"
export * from "./CoursePausedFloatingCard.vue?vue&type=script&lang=js"
import style0 from "./CoursePausedFloatingCard.vue?vue&type=style&index=0&id=34d81380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d81380",
  null
  
)

export default component.exports